<div class="container-fluid">
  <div class="row">
      <div class="col-md-12">
          <div class="card">
              <div class="card-header" style="padding-bottom: 5px !important">
                  <div >
                      <h5 class="pb-2">سعر الذهب</h5>

                     <span> بالرجاء ملئ جميع الحقول </span>
                  </div>
                  <ng-template >
                      
                  </ng-template>
              </div>
              <div class="card-body">
                  <form class="needs-validation" autocomplete="off" 
                  [formGroup] = "GoldPriceForm"
                  (ngSubmit)="onSubmit()" 
                  novalidate>
                      <div class="form-row">
                          <!-- title  -->
                          <!-- appDisableWeritingArabic -->

                          <div class="col-4 mb-3">
                              <label for="validation01"><span class="validation-required">*</span> عيار ١٨</label>
                              <input class="form-control" id="validation01" type="number" onlyNumbers  min="1" formControlName="karat18"
                              [tooltip]="fc.karat18.errors?.required ? 'الحقل مطلوب' : fc.karat18.errors?.min ?  'غير مسموح برقم 0'   : null"
                              [class.is-valid]="fc.karat18.valid && (fc.karat18.touched)"
                              [class.is-invalid]="fc.karat18.invalid && (fc.karat18.touched)"
                                   required
                                   placeholder="عيار ١٨"
                                  containerClass="" />
                          </div>
                          <div class="col-4 mb-3">
                            <label for="validation01"><span class="validation-required">*</span> عيار ٢١</label>
                            <input class="form-control" id="validation01" type="number" onlyNumbers min="1" formControlName="karat21"
                            [tooltip]="fc.karat21.errors?.required ? 'الحقل مطلوب' : fc.karat21.errors?.min ?  'غير مسموح برقم 0' : null"
                            [class.is-valid]="fc.karat21.valid && (fc.karat21.touched)"
                            [class.is-invalid]="fc.karat21.invalid && (fc.karat21.touched)"
                                required
                                placeholder="عيار ٢١"
                                containerClass="" />
                        </div>
                        <div class="col-4 mb-3">
                          <label for="validation01"><span class="validation-required">*</span> عيار ٢٤</label>
                          <input class="form-control" id="validation01" type="number" onlyNumbers min="1" formControlName="karat24"
                          [tooltip]="fc.karat24.errors?.required ? 'الحقل مطلوب' : fc.karat24.errors?.min ? 'غير مسموح برقم 0'  : null"
                          [class.is-valid]="fc.karat24.valid && (fc.karat24.touched)"
                          [class.is-invalid]="fc.karat24.invalid && (fc.karat24.touched)"
                               required
                               placeholder="عيار ٢٤"
                              containerClass="" />
                      </div>
                           
                     </div>
                          
                      <ng-template #elseBlock>
                          <button [disabled]="button" class="btn pull-right" type="submit">
                             حفظ
                          </button>
                          </ng-template>
                      <div *ngIf="update; else elseBlock">
                          <button class="btn pull-right" type="submit">
                              تعديل
                          </button>
                     </div>
                     <div>
                        <label><span>اخر تحديث</span> {{GoldPriceData.lastUpdate | date:'dd/MM/yyyy HH:mm'}}</label>
                    </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
</div>

